export default __webpack_public_path__ + "static/media/back_arrow.9911139e.svg";